import Quill from 'quill';

const Parchment = Quill.import('parchment');

class AudioBlot extends Parchment.Embed {
  static create(url) {
    const node = super.create();

    node.setAttribute('src', url);
    node.setAttribute('controls', '');

    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';

export default AudioBlot;
